AppTabs.createTab( {

name: 'dashboard',
icon: 'columns',
text: 'Dashboard',
create: function(init) {
	'use strict'

	init.setController( new TabControllerVue({
		el: '#v-dashboard',
		methods: {
			resetData() {
				if (this.$children && this.$children instanceof Array) {
					this.$children.forEach( child => {
						if (typeof child.resetData == 'function')
							child.resetData();
					});
				}
			},
			onShowTab: function(openning) {
				if (this.$children && this.$children instanceof Array) {
					this.$children.forEach( child => {
						if (typeof child.onShowTab == 'function')
							child.onShowTab(openning);
						if (openning && typeof child.onOpenTab == 'function')
							child.onOpenTab();
					});
				}
			},
		},
	}) );

}

} );
